import { MAPBOX_API_KEY } from '../../../../constants/index'

export async function getPlaceName(lat, lng) {
  try {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?types=place,region,country&access_token=${MAPBOX_API_KEY}`;
    const res = await fetch(url);
    const data = await res.json();

    if (!data.features?.length) return null;

    let city, state, countryCode;
    for (const f of data.features) {
      if (!city && f.place_type.includes("place")) {
        city = f.text;
      }
      if (!state && f.place_type.includes("region")) {
        state = f.properties?.short_code?.split("-")[1] || f.text;
      }
      if (!countryCode && f.place_type.includes("country")) {
        countryCode = f.properies?.short_code?.toUpperCase() || "US";
      }
      // Break early if we already found all three
      if (city && state && countryCode) break;
    }

    // Build final string like "Chicago IL, US"
    let result = "";
    if (city) result += city;
    if (state) result += (result ? " " : "") + state;
    if (countryCode) result += (state || city ? ", " : "") + countryCode;

    return result || "Nowhere";
  } catch (err) {
    return "Nowhere";
  }
}
